export enum RadioButtonsCron {
    option1 = 'Sin fecha de finalización',
    option2 = 'Finaliza después de un número de repeticiones seleccionadas a continuación: ',
    option3 = 'Finaliza en la fecha seleccionada a continuación: ',
}
